<template>
  <b-modal id="billing-reminder-modal" :visible="visible" 
    @change="onModalChange" 
    centered 
    hide-header 
    hide-footer
    size="md" 
    modal-class="billing-reminder-modal" 
    no-close-on-backdrop 
    no-close-on-esc 
    content-class="p-1">
    <div class="text-center py-1">
      <h5 class="mb-3 font-weight-bold text-left">Billing Reminder</h5>

      <div class="mb-4 text-left" v-html="message"></div>

      <div class="reminder-footer">
        <button @click="onClose" class="confirm-btn">Understood</button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'BillingReminderModal',

  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      message: ''
    };
  },

  created() {
    this.loadReminderMessage();
  },

  methods: {
    ...mapActions('tenantBilling', ['getTenantBillingReminderMessage']),

    async loadReminderMessage() {
      try {
        const msg = await this.getTenantBillingReminderMessage();
        if (!msg?.trim()) return;

        this.message = msg;

        this.$emit('update:visible', true);
      } catch (err) {
        this.$emit('update:visible', false);
      }
    },

    onClose() {
      this.$emit('update:visible', false);
    },

    onModalChange(value) {
      if (!value) this.onClose();
    }
  }
};
</script>

<style scoped>

.reminder-footer {
  display: flex;
  justify-content: flex-end;
}

.confirm-btn {
  border: 1px solid var(--primary-color);
  background-color: transparent;
  color: black;
  padding: .5rem 1rem;
  border-radius: .4rem;
}

.confirm-btn:hover {
  background-color: var(--primary-color);
  color: white;
}

</style>